import { FirestoreDataConverter } from "firebase/firestore";
import { BakingPlan } from "lib-shared-code";
import { PartialConverter } from "../types";
import { genericConverter } from "./generic-converter";

export const bakingPlanConverter: FirestoreDataConverter<BakingPlan> &
  PartialConverter<BakingPlan> = genericConverter<BakingPlan>();
